export default __webpack_public_path__ + "static/media/icons8-cash.d1695d9e.svg";